import { render } from "./CheckPrivacyOptionsEditorCmp.vue?vue&type=template&id=0f948fbb"
import script from "./CheckPrivacyOptionsEditorCmp.vue?vue&type=script&lang=js"
export * from "./CheckPrivacyOptionsEditorCmp.vue?vue&type=script&lang=js"

import "./CheckPrivacyOptionsEditorCmp.vue?vue&type=style&index=0&id=0f948fbb&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__